<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader>
                    <strong>Сегменты клиентов</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <div v-show="!loading">
                        <CDataTable
                            hover
                            :items="segments"
                            :fields="fields">
                            <template #id="data">
                                <td>
                                    <CLink :to="`/segments/${data.item.id}`">{{
                                        data.item.id
                                    }}</CLink>
                                </td>
                            </template>
                            <template #name="data">
                                <td>
                                    <CLink :to="`/segments/${data.item.id}`">{{
                                        data.item.name
                                    }}</CLink>
                                </td>
                            </template>
                            <template #customer_count="data">
                                <td>
                                    {{ data.item.customer_ids ? data.item.customer_ids.length : 0 }}
                                </td>
                            </template>
                            <template #update_frequency="data">
                                <td>
                                    {{ getUpdateFrequencyLabel(data.item.update_frequency_hours) }}
                                </td>
                            </template>
                            <template #last_updated_at="data">
                                <td>
                                    {{ data.item.last_updated_at ? formatDate(data.item.last_updated_at) : 'Никогда' }}
                                </td>
                            </template>
                            <template #enabled="data">
                                <td>
                                    <CBadge :color="getBadge(data.item.enabled)">&nbsp;{{
                                        data.item.enabled ? "Да" : "Нет"
                                    }}&nbsp;</CBadge>
                                </td>
                            </template>
                            <template #is_system="data">
                                <td>
                                    <CBadge v-if="data.item.is_system" color="info">Системный</CBadge>
                                    <span v-else class="text-muted">Обычный</span>
                                </td>
                            </template>
                            <template #created_at="data">
                                <td>
                                    {{ formatDate(data.item.created_at) }}
                                </td>
                            </template>
                            <template #actions="data">
                                <td>
                                    <CButton
                                        color="info"
                                        size="sm"
                                        class="mr-2"
                                        @click="refreshSegment(data.item.id)">
                                        Обновить
                                    </CButton>
                                    <CButton
                                        color="primary"
                                        size="sm"
                                        :to="`/segments/${data.item.id}`">
                                        Открыть
                                    </CButton>
                                </td>
                            </template>
                        </CDataTable>
                        <CPagination
                            :active-page.sync="activePage"
                            class="mt-4"
                            :pages="totalPages"
                            align="center"
                        />
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');

    export default {
        name: 'Segments',

        data() {
            return {
                loading: true,
                segments: [],
                totalPages: 1,
                fields: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'name', label: 'Название' },
                    { key: 'customer_count', label: 'Количество клиентов' },
                    { key: 'update_frequency', label: 'Частота обновления' },
                    { key: 'last_updated_at', label: 'Последнее обновление' },
                    { key: 'enabled', label: 'Активен' },
                    { key: 'is_system', label: 'Тип' },
                    { key: 'created_at', label: 'Дата создания' },
                    { key: 'actions', label: 'Действия' }
                ]
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                    await this.fetch();
                }
            }
        },

        async mounted() {
            await this.fetch();
            this.loading = false;
        },

        methods: {
            formatDate,
            
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },

            getUpdateFrequencyLabel(hours) {
                if (!hours) {
                    return 'Стандартная';
                }
                const labels = {
                    1: 'Каждый час',
                    2: 'Каждые 2 ч',
                    3: 'Каждые 3 ч',
                    6: 'Каждые 6 ч',
                    12: 'Каждые 12 ч',
                    24: 'Каждый день',
                    48: 'Каждые 2 дня',
                    72: 'Каждые 3 дня',
                    168: 'Каждую неделю'
                };
                return labels[hours] || `${hours} ч`;
            },

            async fetch() {
                try {
                    const response = await Vue.axios.get('/segments', {
                        params: {
                            page: this.activePage,
                            limit: 20
                        }
                    });
                    this.segments = response.data.data;
                    this.totalPages = response.data.pagination.totalPages;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки сегментов.');
                    console.error(err);
                }
            },

            async refreshSegment(segmentId) {
                try {
                    await Vue.axios.post(`/segments/${segmentId}/refresh`);
                    this.$root.$emit('showSuccess', 'Сегмент обновлен.');
                    await this.fetch();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка обновления сегмента.');
                    console.error(err);
                }
            },

            async deleteSegment(segmentId) {
                if (confirm('Вы уверены, что хотите удалить этот сегмент?')) {
                    try {
                        await Vue.axios.delete(`/segments/${segmentId}`);
                        this.$root.$emit('showSuccess', 'Сегмент удален.');
                        await this.fetch();
                    } catch (err) {
                        this.$root.$emit('showError', 'Ошибка удаления сегмента.');
                        console.error(err);
                    }
                }
            }
        }
    };
</script> 